import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Popover, TextField, Fab } from '@mui/material';
import i18n from "@/languages/index";

const FloatingSearchButton = (props) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openedPopover, setOpenedPopover] = useState(false)

  const popoverEnter = ({ currentTarget }) => {
    setOpenedPopover(true)
  };

  const popoverLeave = ({ currentTarget }) => {
    setOpenedPopover(false)
  };

  const handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    if (!openedPopover){
      setOpen(!open);
    }
    else {
      setOpen(true);
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleTextSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      props.onSearch(searchText);
      setOpen(false);
    }
  };

  return (
    <Fab
      color="primary"
      aria-label="search"
      style={{
        marginRight: 10,
        marginLeft: 10
      }}
      onClick={handleClick}
    >
      <SearchIcon />
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        onClose={handleClose}
        PaperProps={{variant: 'outlined', onMouseEnter: popoverEnter, onMouseLeave: popoverLeave }}
        style={{overflowY: "hidden"}}
      >
        <div style={{ margin: 10 }}>
          <TextField
            label={i18n.t('common:text.floating_search_button_placeholder')}
            onChange={handleTextSearchChange}
            onKeyPress={handleKeyDown}
            value={searchText}
            autoFocus
          />
        </div>
      </Popover>
    </Fab>
  );
};

export default FloatingSearchButton;
